<template>
  <div>
    <div>
      <el-button
        v-if="editMySignatures"
        small
        :title="getEditMySignaturesTitle"
        :loading="loading"
        color="primary"
        @click.native="editSignatures(mySignature)"
      />
    </div>
    <div v-if="showProcuracyText">{{ $t('Prokūrą išduodančio valdymo organo nariai ar juridinio asmens savininkas arba jo įgaliotas asmuo juridinio asmens steigimo dokumentuose nustatyta tvarka') }}</div>
    <div>
      <h2 class="mt-1" style="display: flex;">{{ getListTitle }}</h2>
      <div style="color:red" class="mb-2">{{ getInfoText }}</div>
        <template v-if="signatures.length">
          <template v-for="(signature, index) in signatures">
            <v-card :class="getClass(signature, index)" :key="index" outlined>
              <v-card-text class="pa-2" :style="signature.borderColorRed ? `border: 2px solid #ff5252; background: rgb(255 235 235);` : ''">
                <v-row>
                  <v-col cols="1">
                    <div v-if="signature.canEdit">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-on="on" v-bind="attrs" :color="getIconColor(signature)" @click.native="editSignatures(signature)">mdi-pencil-outline</v-icon>
                        </template>
                        <div class="tooltip-text">{{ $t('Pridėkite atstovus / redaguokite pasirašančiųjų eilę ir kontaktus') }}</div>
                      </v-tooltip>
                    </div>
                    <v-icon v-else :color="getIconColor(signature)">{{getIcon(signature)}}</v-icon>
                  </v-col>
                  <v-col :cols="showFull(signature) ? 11 : 8" style="padding-top:0.9rem">
                    <span>{{signature.fullname}}</span>
                  </v-col>
                  <v-col v-if="!showFull(signature)" style="text-align: center; padding-top:0.9rem; align-self: center;" cols="3">
                    <span>{{getStatusText(signature)}}</span>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </template>
        </template>
        <template v-else-if="!loadingList && signatures.length == 0">
          <v-card outlined>
            <v-card-text class="pa-2" :style="`border: 2px solid #ff5252; background: rgb(255 235 235);`">
              <v-row>
                    <v-col cols="1">
                      <v-icon :color="`red`">mdi-close-circle</v-icon>
                    </v-col>
                    <v-col cols="6" style="padding-top:0.9rem">
                      <span>{{ mySignature.asm_pavadinimas }}</span>
                    </v-col>
                    <v-col style="text-align: end; padding-top:0.9rem" cols="4">
                      <span>{{ $t('Pridėti atstovus!') }}</span>
                    </v-col>
                  </v-row>
                </v-card-text>
          </v-card>
        </template>
      <modal-signatures-order
        v-model="showSignaturesModal"
        :loading="loading"
        :selectedSignatureId="selectedSignature.id"
        :allowDelete="allowDelete"
        :modalCardTitle="modalCardTitle"
        :turnOnAddrepresenter="emitOnSave"
        :emitOnSave="emitOnSave"
        :signaturesFromParent="signatures"
        :selectedFromParent="selectedSignature"
        :onlyOrder="onlyOrder"
        :dataType="dataType"
        @saveEvent="emitSaveEvent"
        @closeModal="closeSignaturesModal"
      />
    </div>
  </div>
</template>

<script>
  import InJournalStatuses from '@/components/constants/inJournalStatus'
  import InJournalTypes from '@/components/constants/inJournalTypes'
  import ModalSignaturesOrder from '@/components/modals/ModalSignaturesOrder.vue'

  export default {
    name: 'SignaturesList',
    components: {ModalSignaturesOrder},
    props: {
      dataType: { type: String, default: 'jur_representer_against_parent' },
      signatures: [Array],
      status: [String, Number],
      editMySignatures: [Boolean],
      mySignature: [Object],
      inJournalType: [String],
      // TITLES
      editMySignaturesTitle: [String],
      listTitle: [String],
      modalCardTitle: [String, undefined],

      // When direct saving is not needer
      emitOnSave:[Boolean],
      onlyOrder:[Boolean],
      loadingList: { type: Boolean, default: true },
      hideInfo:[Boolean],
    },
    data() {
      return {
        showSignaturesModal: false,
        selectedSignature: {},
        loading: false,
        allowDelete: false,
      }
    },
    created() {},
    computed: {
      // TITLES
      getEditMySignaturesTitle() {
        if (this.inJournalType != undefined && (this.inJournalType == "421" || this.inJournalType == "420") ) {
          if(this.getInfoTextByStatus){
            return  this.$t('Pridėti / Redaguoti prokūrą išduodančio valdymo organo narius ir kontaktus')
          }
          return this.editMySignaturesTitle ?? this.$t('Pridėti / Redaguoti prokūrą išduodančio valdymo organo narius ir kontaktus')
        }

        if(this.getInfoTextByStatus){
          return  this.$t('Pridėti atstovus / redaguoti pasirašančiųjų eilę ir kontaktus')
        }
        return this.editMySignaturesTitle ?? this.$t('Pridėti atstovus / redaguoti pasirašančiųjų eilę ir kontaktus')
      },
      showProcuracyText() {
        return this.inJournalType != undefined && (this.inJournalType == "421" || this.inJournalType == "420" || this.inJournalType == '422')
      },
      getListTitle() {
        if (this.inJournalType != undefined && this.inJournalType == "421") {
          return this.$t('Atstovai');
        }
        return this.listTitle ?? this.$t('Pasirašantys asmenys')
      },
      getInfoText() {
        if (this.hideInfo || ( this.inJournalType != undefined && (this.inJournalType == "421")) ) {
          return '';
        }
        return this.$t('Dokumento pasirašymas vyksta eilės tvarka. Jei negalite pasirašyti dokumento – jo dar nėra pasirašęs ir turi tai padaryti asmuo, esantis aukščiau pasirašymo eilėje. Dokumentas registravimui perduodamas tik po to, kai paskutinis sąraše esantis asmuo pasirašo ir sumokama už paslaugą.')
      },
      getInfoTextByStatus(){
        return this.status == InJournalStatuses.ATSTOVAI_PATVIRTINTI
      }
    },
    methods: {
      emitSaveEvent(signatures) {
        this.$emit('saveEvent', signatures)
      },
      closeSignaturesModal() {
        this.selectedSignature = {};
        this.selectedSignatureId = null;
      },
      editSignatures(signature) {
        if (this.onlyOrder) {
          this.allowDelete = false
        } else {
          this.allowDelete = signature.canEdit
          this.selectedSignature = signature
        }
        this.showSignaturesModal = true
      },

      // STYLES
      getClass(signature, index){
        if(signature.signed){
          if(this.status == InJournalStatuses.ATSAUKTAS && index == 0) { return 'card-signed-cancel mb-3' }
          return 'card-signed mb-3'
        } else if(signature.rejected || signature.showRed) {
          return 'card-rejected mb-3'
        } else {
          return 'mb-3'
        }
      },
      getIcon(signature){
        if(signature.signed){
            return 'mdi-check-bold'
          } else if(signature.rejected || signature.borderColorRed) {
            return 'mdi-close-circle'
          } else {
            return 'mdi-clock-time-two'
          }
      },
      getIconColor(signature){
        if(signature.signed){
            return 'primary'
          } else if(signature.rejected || signature.borderColorRed) {
            return 'red'
          } else {
            return 'secondary'
          }
      },
      getStatusText(signature){
        if (signature.textToShow) {
          return signature.textToShow
        } else if(signature.signed || signature.rejected){
          return signature.time
        } else {
          if(this.status == InJournalStatuses.ATSAUKTAS ){ return '' }
          return this.$t('Laukiama pasirašymo')
        }
      },
      showFull(signature){
        let status = this.getStatusText(signature)
        return (status == null || status == '' || status == ' ')
      },
    },
  }
</script>


<style lang="scss" scoped>
  .card-signed{
    background-color: #cbebe7;
    border-color: #198677;
  }

  .card-signed-cancel{
    background-color: #cbebe7;
    border: 2px solid #f11a1ac7;
  }

  .card-rejected{
    background-color: #fff0f0 ;
    border-color: #f11a1a;
  }

</style>
